import { render, staticRenderFns } from "./ProfileSettings.vue?vue&type=template&id=350bc575&scoped=true"
import script from "./ProfileSettings.vue?vue&type=script&lang=js"
export * from "./ProfileSettings.vue?vue&type=script&lang=js"
import style0 from "./ProfileSettings.styl?vue&type=style&index=0&id=350bc575&prod&scoped=true&lang=stylus&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350bc575",
  null
  
)

export default component.exports